import { useNavigate } from 'react-router-dom';
import { default as Box } from '@mui/material/Box';
import { MenuLink, MenuLinkTitle } from 'components/MenuLink';
import { PageHeader } from 'components/PageHeader';
import { PATHS } from 'config/paths';
import { getTrans } from 'modules/i18n';
import { Layout } from 'modules/minimal-ui-theme';
import { FeatureFlag, useFeatureToggle } from 'modules/unleash';

export const PrivacySettingsPage = () => {
  const navigate = useNavigate();

  const { isEnabled: isGeolocationEnabled } = useFeatureToggle(
    FeatureFlag.PRO_TALENT_IS_GEOLOCATION_ENABLED
  );

  return (
    <Layout
      header={
        <PageHeader
          title={getTrans('profilePage.linkLabel.privacySettings')}
          withBackBtn
        />
      }
      childrenStyles={{ p: 0 }}
      withFooter
    >
      <Box sx={{ mt: 10 }}>
        <MenuLink
          onClick={() => window.open(getTrans('url.privacyPolicy'), '_blank')}
          dataTestId="privacy-policy-link"
          withArrow={true}
        >
          <MenuLinkTitle>
            {getTrans('profilePage.linkLabel.privacyPolicy')}
          </MenuLinkTitle>
        </MenuLink>
        <MenuLink
          onClick={() => window.__ucCmp?.showSecondLayer()}
          dataTestId="privacy-consent-link"
          withArrow={true}
        >
          <MenuLinkTitle>
            {getTrans('profilePage.linkLabel.privacyConsent')}
          </MenuLinkTitle>
        </MenuLink>
        {isGeolocationEnabled && (
          <MenuLink
            onClick={() => navigate(PATHS.geolocation)}
            dataTestId="geolocation-permission-link"
            withArrow={true}
          >
            <MenuLinkTitle>
              {getTrans('profilePage.linkLabel.geolocation')}
            </MenuLinkTitle>
          </MenuLink>
        )}
      </Box>
    </Layout>
  );
};
